import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/Testimonials/Testimonials.js
const Testimonials = createSectionForm({
  icon: "chat-quote-line",
  title: "Testimonials",
  fields: [
    { name: "title", label: "Section Title" },
    { name: "badge_text", label: "Badge Text", placeholder: "verified owner" },
    {
      name: "testimonials",
      label: "Testimonials",
      type: "list",
      itemLabel: "Testimonial",
      fields: [
        { name: "image", label: "Photo", type: "media" },
        { name: "name", label: "Customer Name" },
        { name: "date", label: "Date", placeholder: "YYYY-MM-DD" },
        { name: "rating", label: "Rating", type: "number", min: 1, maxValue: 5 },
        { name: "review", label: "Review", type: "textarea" },
      ],
    },
  ],
});

export default Testimonials;
